import { SET_HOME_DATA } from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_HOME_DATA: {
      return [...action.payload];
    }
    default:
      return state;
  }
}
